import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useTrOOPScheduleStepMessage from "./hooks/useTrOOPScheduleStepMessage";  
  
const TrOOPScheduleStepMessage = () => {  
  const troopScheduleStepMessageData = useTrOOPScheduleStepMessage();  
  
  return (  
    <div class="container container-fluid">  
        <ButtonsSection ctaButtons={troopScheduleStepMessageData.leftButtons} align="left" />
      <div className="header-section">  
        <h1>  
          {troopScheduleStepMessageData.screen_title} -{" "}  
          <span className="heading-cod">  
            {troopScheduleStepMessageData.screenNumber}  
          </span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={troopScheduleStepMessageData.formFields}  
        dropdownValues={troopScheduleStepMessageData.dropdownValues}  
        paramsData={troopScheduleStepMessageData.paramsData}  
        updataParamData={troopScheduleStepMessageData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={troopScheduleStepMessageData.ctaButtons} />  
      <DisplayTable  
        data={troopScheduleStepMessageData.data}  
        parmKey={troopScheduleStepMessageData.parmKey}  
        menuOptions={troopScheduleStepMessageData.menuOptions}  
        tableHeaders={troopScheduleStepMessageData.columnDef}  
        setRowData={troopScheduleStepMessageData.setRowData}  
        selectedPriceSchedules={troopScheduleStepMessageData.selectedRows}  
        setSelectedPriceSchedules={troopScheduleStepMessageData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={troopScheduleStepMessageData.first}  
          rows={troopScheduleStepMessageData.rows}  
          totalRecords={troopScheduleStepMessageData.totalRecords}  
          currentPage={troopScheduleStepMessageData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={troopScheduleStepMessageData.onPageChange}  
        />  
      </div>  
      {troopScheduleStepMessageData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={troopScheduleStepMessageData.isConfirmationModalOpen}  
          onRequestClose={troopScheduleStepMessageData.closeConfirmationModal}  
          onBack={troopScheduleStepMessageData.closeConfirmationModal}  
          onSave={troopScheduleStepMessageData.deleteTrOOPScheduleStepMessage}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={troopScheduleStepMessageData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default TrOOPScheduleStepMessage;